import initIndex from './utilities/algoliaInitIndex'
import createFilter from './utilities/algoliaCreateFilter'

const itemsIndex = initIndex('items')

const algoliaSearchItem = async ({ query, facets }) => itemsIndex.search({
	query,
	filters: createFilter(facets),
	hitsPerPage: 24,
	page: 0,
	//  Highlighting not required
	attributesToHighlight: []
}).catch((error) => { //  TODO: Add to error types/messages
	console.log('ALGOLIA ERROR', error)
	return { error, query }
})

export default algoliaSearchItem



// WEBPACK FOOTER //
// ./src/dataservices/algoliaSearchItem.js